<template>
	<GridLayout grid-fluid>
		<template v-for="(item, index) in campList">
			<c-new-col :key="`camp-${index}`" :col-lg="3" class="mb-12">
				<EduCardInGrid
					:type="type"
					:camp="item"
					:is-free-schedule="false"
					@clickEduCard="goEduDetail(item.url, item.no, item.title)"
				/>
			</c-new-col>
		</template>
	</GridLayout>
</template>

<script>
import eduCampMixin from '../../mixins/edu/eduCamp';
import { mapGetters } from 'vuex';
import GridLayout from '../common/GridLayout.vue';
import EduCardInGrid from './EduCardInGrid.vue';

export default {
	mixins: [eduCampMixin],
	props: {
		campList: Array,
		partner: Object,
		name: String,
		userNo: Number,
		userId: String,
		userType: Number,
		filter: Boolean,
		count: Number,
		type: String,
		freeSchedule: {
			type: Boolean,
			default: false,
		},
		rentalClassroom: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters({
			storeKeyword: 'keyword',
		}),
		isPartner() {
			return this.partner.name !== 'comento';
		},
	},
	methods: {
		goEduDetail(url, no, title) {
			//GTM
			if (this.name === 'recommend-camp') {
				clickEduBanner(
					this.userNo,
					this.userType,
					this.userId,
					'recommend',
					'eduList',
					'viewEduDetail',
					null,
					no,
					this.comentoLocalStorageId,
				);
			}

			if (this.rentalClassroom) {
				const isShowPermossionInfo = {
					show: true,
					title: title,
					campNo: no,
				};
				this.$emit('isShowPermossion', isShowPermossionInfo);
			}
		},
	},
	components: { EduCardInGrid, GridLayout },
};
</script>

<style lang="scss" scoped></style>
